const NotificationCard = ({data, onClickCard}) => {
    return (
        <div className="notificationCard">
            <p className="time">{data?.date}</p>
            {data.list.map((item) => (
                <div className="contentWrapper" onClick={() => onClickCard(item)}>
                    <div className={"content"} key={item.id}>
                        <div className={`read ${!item.is_read && "isNew"}`}></div>
                        <div className="notificationImg">
                            {item.image && <img src={item.image} alt="notificationImg"/>}
                        </div>
                        <div className="notificationInfo">
                            {/* <h5 className="contentTitle lineClamp">{item.title}</h5> */}
                            <p className="desc lineClamp">{item.description}</p>
                        </div>
                    </div>
                    <p className="clock">{item?.created_at}</p>
                </div>
            ))}
        </div>
    );
};

export default NotificationCard;
